import { render } from "./RecipesReviewModal.vue?vue&type=template&id=12ac1e78&scoped=true"
import script from "./RecipesReviewModal.vue?vue&type=script&lang=js"
export * from "./RecipesReviewModal.vue?vue&type=script&lang=js"

import "./RecipesReviewModal.vue?vue&type=style&index=0&id=12ac1e78&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ac1e78"]])

export default __exports__